import {
  useContractDemandRequestLinePrefill,
  UseContractDemandRequestLinePrefillProps,
} from './ContractDemandRequestLinePrefill.hook.ts';

export const ContractDemandRequestLinePrefill = (props: UseContractDemandRequestLinePrefillProps) => {
  useContractDemandRequestLinePrefill(props);
  return null;
};
